var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":"","height":"6","rounded":""}}):_c('div',[(_vm.resolvedText !== null && _vm.resolvedText !== undefined)?_c('span',[_vm._v(" "+_vm._s(_vm.resolvedText)+" ")]):_c('span',{staticClass:"grey--text text--darken-1"},[_vm._v(" — ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }